
webpack.register(
    'components/image-cloudinary/image-cloudinary',
    function() {
        return import('components/image-cloudinary/image-cloudinary');
    },
    true
);